module.exports = __webpack_public_path__ + "static/img/course2.b63d568b.png";